import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { getTags } from "../redux/reduxApi/admin/TagReduxApi";

const useTagSearch = (options = {}) => {
  const { pageSize = 30, searchField = "tagName" } = options;

  const dispatch = useDispatch();

  const loadTags = useCallback(
    async (search, loadedOptions, { page = 1 }) => {
      const searchCriteria = [];

      if (search && search.trim()) {
        searchCriteria.push({
          field: searchField,
          operation: "contains",
          value: search.trim(),
        });
      }

      try {
        const response = await dispatch(
          getTags({
            page,
            size: pageSize,
            search: searchCriteria,
          })
        );

        const tags = response.payload?.data?.tagMasters || [];

        const options = tags.map((tag) => ({
          label: tag.tagMasters.tagName,
          value: tag.tagMasters.ROWID,
        }));

        return {
          options,
          hasMore: tags.length === pageSize,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error loading tags:", error);

        return {
          options: [],
          hasMore: false,
          additional: { page },
        };
      }
    },
    [dispatch, pageSize, searchField]
  );

  return { loadTags };
};

export default useTagSearch;